/**
 * Was this element focused from the KEYBOARD? `:focus-visible` is the browser's
 * own answer. A click also focuses a button, and the rail treats the two
 * differently — the island restores focus only for a keyboard opener, and the
 * well scrolls a keyboard-focused tile clear of its fade but never moves the list
 * under a pointer mid-press. One probe, so the two cannot disagree about the same
 * focus event.
 */
export function isKeyboardFocus(el: Element | null | undefined): boolean {
  if (!el) return false
  try {
    return el.matches(':focus-visible')
  } catch {
    // A browser without `:focus-visible`: treat focus as pointer focus — the
    // cautious answer for both callers.
    return false
  }
}
